import { useEffect } from 'react';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { generateUuidV4 } from 'reactApp/utils/helpers';
import { getFirstLevelDomain } from 'reactApp/utils/urlHelper';

export const useOnPremiseSessiondIdCookie = () => {
    useEffect(() => {
        if (IS_ONPREMISE) {
            document.cookie = `_unzip_session_id=${generateUuidV4()}; Domain=.${getFirstLevelDomain()}; Max-Age=31536000; Path=/; Secure; SameSite=Lax`;
        }
    }, []);
};
